// extracted by mini-css-extract-plugin
export var addButton = "_oy-0";
export var border = "_oy-8";
export var check = "_oy-h";
export var danger = "_oy-6";
export var dropdownContainer = "_oy-1";
export var editModalBody = "_oy-j";
export var footerContainer = "_oy-i";
export var fullWidth = "_oy-a";
export var hide = "_oy-9";
export var icon = "_oy-3";
export var input = "_oy-7";
export var inputFlex = "_oy-b";
export var inputWrapper = "_oy-c";
export var manualFocus = "_oy-5";
export var optionButton = "_oy-4";
export var pillWrapper = "_oy-e";
export var pointer = "_oy-2";
export var showOverflow = "_oy-f";
export var tagsFlex = "_oy-d";
export var xButton = "_oy-g";